import { render, staticRenderFns } from "./EmployeeQuotasSummaryView.vue?vue&type=template&id=16a15cde&"
import script from "./EmployeeQuotasSummaryView.vue?vue&type=script&lang=ts&"
export * from "./EmployeeQuotasSummaryView.vue?vue&type=script&lang=ts&"
import style0 from "./EmployeeQuotasSummaryView.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports